export default {
	xsmall: '240',
	small: '360',
	medium: '480',
	large: '720',
	xlarge: '1080',
}
